import { ReactComponent as VisaIcon } from "assets/icons/payment/visa.svg";
import { ReactComponent as MastercardIcon } from "assets/icons/payment/master-id-check.svg";
import { ReactComponent as MastercardWhiteTextIcon } from "assets/icons/payment/master-id-check-white.svg";
import { ReactComponent as PciIcon } from "assets/icons/payment/pci-dss.svg";

export const paymentIconsListDefault = [VisaIcon, MastercardIcon, PciIcon];
export const paymentIconsListMapPaywall = [VisaIcon, MastercardWhiteTextIcon, PciIcon];
